/** @jsxImportSource @emotion/react */
import { Emoji } from 'emoji-picker-react'
import { css } from '@emotion/css'
import React from 'react'

const EmojiPreview = ({ value, onChange, size = 24, ...props }) => {
  const inputStyles = css`
    display: flex;
    align-items: center;
    justify-content: start;
    cursor: default;
    width: fit-content;

    & span {
      line-height: 1 !important;
      width: fit-content !important;
      height: ${size}px !important;
    }
  `

  return (
    <div className={inputStyles}>
      <Emoji unified={value} size={size} emojiStyle="native" {...props} />
    </div>
  )
}

export default EmojiPreview
